<button mat-button [matMenuTriggerFor]="columnMenu">
  <mat-icon>{{ icon() }}</mat-icon>
  <span>{{ !mobileQuery.matches ? text() : "" }}</span>
</button>

<mat-menu class="acciones" #columnMenu="matMenu">
  <div cdkDropList class="list" (click)="$event.stopPropagation()">
    @for (column of columnInfo; track column; let i = $index) {
      <div
        class="box"
        cdkDrag
        [cdkDragData]="{ columnIndex: i, columnTitle: column.id }"
        (cdkDragDropped)="columnMenuDropped($event)"
        [cdkDragDisabled]="!drag"
      >
        <div
          class="row fill gap-12px"
          style="display: flex; align-items: center"
        >
          <div class="custom-placeholder" *cdkDragPlaceholder></div>
          @if (drag) {
            <mat-icon
              cdkDragHandle
              color="primary"
              [ngClass]="{ 'cursor-move': drag }"
            >
              drag_indicator
            </mat-icon>
          }
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="toggleSelectedColumn(column.id)"
            [checked]="!column.hidden"
          >
            {{ column.name }}
          </mat-checkbox>
        </div>
      </div>
    }
  </div>
</mat-menu>
